module.exports = __webpack_public_path__ + "static/media/S1_00033.ba30b1fc.jpg";